import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "types/api.types";
import type {
  CreateSupplierPayload,
  Supplier,
  SupplierListFilters,
  UpdateSupplierPayload,
} from "../types/supplier.types";

export const getSuppliersList = async (params: SupplierListFilters = {}) => {
  const { page = 1, limit = 10, search } = params;
  const response = await axiosClient.post<ApiResponse<ApiList<Supplier[]>>>(
    "/suppliers/list",
    {
      page,
      limit,
      ...(search ? { search } : {}),
    },
  );
  return response.data;
};

export const createSupplier = async (payload: CreateSupplierPayload) => {
  const response = await axiosClient.post<ApiResponse<Supplier>>(
    "/suppliers",
    payload,
  );
  return response.data;
};

export const getSupplier = async (id: number) => {
  const response = await axiosClient.get<ApiResponse<Supplier>>(
    `/suppliers/${id}`,
  );
  return response.data;
};

export const updateSupplier = async (
  id: number,
  payload: UpdateSupplierPayload,
) => {
  const response = await axiosClient.put<ApiResponse<Supplier>>(
    `/suppliers/${id}`,
    payload,
  );
  return response.data;
};

export const deleteSupplier = async (id: number) => {
  const response = await axiosClient.delete<ApiResponse<unknown>>(
    `/suppliers/${id}`,
  );
  return response.data;
};

/** For AsyncPaginatedSelect — maps list rows to option shape. */
export const getSupplierOptions = async ({
  query,
  page = 1,
  limit = 50,
}: {
  query?: string;
  page?: number;
  limit?: number;
}): Promise<ApiResponse<ApiOptionList>> => {
  const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
    "/suppliers/options",
    { params: { query, page, limit } },
  );
  return response.data;
};
